import PropTypes from 'prop-types';

import {
  ClassNameDefaultProps,
  ClassNamePropTypes,
} from '@/common/proptypes/Base/ClassName.protypes';

export const SectionsContentDefaultProps = {
  ...ClassNameDefaultProps,
  allDepths: [],
  Categories: [],
};

export const SectionsContentPropTypes = {
  ...ClassNamePropTypes,
  allDepths: PropTypes.arrayOf(PropTypes.string),
  Categories: PropTypes.arrayOf(
    PropTypes.shape({
      slug: PropTypes.string,
      label: PropTypes.string,
    }),
  ),
};
